<div class="table-layout">
    <div class="table-operation">
        <button nButton id="front-table-client-nfs-share-refresh" style="float: right;" icon="icon-refresh" (click)="refresh()">
        </button>
        <n-button-group [relateTable]="dt" [items]="[addBtn, removeBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt
            id="front-table-client-nfs-share-table"
            style="height: 4rem;"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs"
            [data]="tableData"
            [(selection)]="selection"
            [simpleMode]="SWITCH.IS_SIMPLE_MODE">
        </n-data-table>
    </div>
</div>
